import { useQuery } from "react-query";
import { getCatalogData } from "../catalogApi";

export default function useGetDataCatalogApplications(params) {
  return useQuery({
    queryKey: ["getCatalogData", params],
    queryFn: () => getCatalogData(params),
    refetchOnWindowFocus: false,
    enabled: !!params,
  });
}
